exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mobileElementGroup_2o0i4ZpacHWtW3ExdvBSf_ {\n  width: calc(100% + 10px);\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 20px;\n  overflow: hidden;\n  float: left;\n  clear: both;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"mobileElementGroup": "mobileElementGroup_2o0i4ZpacHWtW3ExdvBSf_"
};